// Common
import './lib/common/common.js';

// Load Web components
import '../components/kw-button-languages/kw-button-languages.js';
import '../components/kw-footer/kw-footer.js';
import '../components/kw-header/kw-header.js';
import '../components/kw-banner/kw-banner.js';
import '../components/kw-section/kw-section.js';
import '../components/kw-media-carousel/kw-media-carousel.js';
import '../components/kw-title/kw-title';
import '../components/kw-tab-list/kw-tab-list';

// Load libraries
import './lib/scroll/scroll.js';

import DataLanguage from './lib/data-language.js';
import dataBanner from './lib/dataBanner.js';
import dataBanners from '../json/developmentBannerData.json';

const { lang } = document.querySelector('html');

const componentName = 'development';

function banner() {
  const bannerData = document.getElementById('banner-development');
  bannerData.innerHTML = `
          <kw-banner id="Banner" banner-size="development" animation-type="slide-toleft" change-interval="8" >
              ${DataLanguage.dataLanguage(dataBanners.developmentBannerData, lang).map(dataBanner.banner).join('')}
          </kw-banner>
    `;
}

function cardsAnimation() {
  const section = document.querySelector('#services');
  const wrapper = section.querySelectorAll('.card-container');

  const options = {
    threshold: 0.3,
  };
  /* eslint-disable-next-line */
  function callBack(entries, observer) {
    if (entries[0].isIntersecting) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < wrapper.length; i++) {
        wrapper[i].classList.add('card-animation');
        wrapper[i].classList.add(`card-delay-${i}`);
      }
    }
  }

  const observerServices = new IntersectionObserver(callBack, options);
  observerServices.observe(section);
}

function svgAnimation() {
  const section = document.querySelector('#services');
  const svg = document.querySelector('#services-illustration');
  const svgList = svg.querySelectorAll('.svg-list');

  const options = {
    threshold: 0.3,
  };
  /* eslint-disable-next-line */
  function callBack(entries, observer) {
    if (entries[0].isIntersecting) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < svgList.length; i++) {
        svgList[i].classList.add('animation-item');
      }
    }
  }

  const observerServices = new IntersectionObserver(callBack, options);
  observerServices.observe(section);
}

function stackTechnologicalAnimation() {
  const section = document.querySelector('#stack-icons');
  const wrapper = section.querySelectorAll('.development__stack-techcological--icon');
  const text = section.querySelectorAll('.development__stack-techcological-text');
  const image = section.querySelector('.development__stack-techcological--image');

  const options = {
    threshold: 0.4,
  };
  /* eslint-disable-next-line */
  function callBack(entries, observer) {
    if (entries[0].isIntersecting) {
      image.classList.add('image-animation');
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < wrapper.length; i++) {
        wrapper[i].classList.add('icon-animation');
        wrapper[i].classList.add(`icon-delay-${i}`);
        text[i].classList.add('text-animation');
        text[i].classList.add(`text-delay-${i}`);
      }
    }
  }
  const observerServices = new IntersectionObserver(callBack, options);
  observerServices.observe(section);
}

function casesAnimation() {
  const section = document.querySelector('#cases');
  const wrapper = section.querySelector(`.${componentName}__cases-inner`);
  const image = section.querySelector(`.${componentName}__cases-image`);

  const options = {
    threshold: 0.4,
  };
  /* eslint-disable-next-line */
  function callBack(entries, observer) {
    if (entries[0].isIntersecting) {
      wrapper.classList.add(`${componentName}__cases-inner--visible`);
      image.classList.add(`${componentName}__cases-image--visible`);
    }
  }

  const observerImages = new IntersectionObserver(callBack, options);
  observerImages.observe(section);
}

function changeCases() {
  document.querySelector('kw-tab-list#development').addEventListener('kw-tab-list:clicked', ({ detail }) => {
    const { index } = detail;
    const images = document.querySelectorAll(`.${componentName}__cases-image img`);
    images.forEach((image, imageIndex) => {
      // eslint-disable-next-line no-param-reassign
      image.hidden = imageIndex !== parseInt(index, 10);
    });
  });

  casesAnimation();
}

function handleLoadWindowFunctions() {
  banner();
  cardsAnimation();
  svgAnimation();
  changeCases();
  stackTechnologicalAnimation();
}

if (document.addEventListener) {
  window.addEventListener('load', handleLoadWindowFunctions);
}
